import { createAction } from '@reduxjs/toolkit';

export const updateIntegrationStatus = createAction<{
  connectorId: string;
  status: boolean;
}>('updateIntegrationStatus');
